import Vue from 'vue'
import VueRouter from 'vue-router'

// import HOME from './modules/zh-CN/home' // home模块 -中文
// import SINGLE from './modules/zh-CN/single' // single模块 -中文
// import HOME_EN from './modules/en-US/home' // home模块 -英文
// import SINGLE_EN from './modules/en-US/single' // single模块 -英文
import Home from '@/views/Home'
Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) { // 解决重复路由路径报错问题
   return originalPush.call(this, location).catch(err => err)
}

const Login = () => import(/* webpackChunkName: "login" */ '../views/Login');

const lang = localStorage.getItem('language-type') || 'zh-CN';

let commonVue = require.context('@/views/common', true, /\.vue$/);
let homeRoutes = [];
commonVue.keys().map(path=>{
    let name = path.slice(path.lastIndexOf('/')+1,path.length-4).toLowerCase()
    const VueModule = () => import(/* webpackChunkName: "common" */ `@/views/common${path.slice(1)}`);
    homeRoutes.push({path:`${lang}/${name}`, name:name ,component:VueModule})
})

// if(lang === "zh-CN"){
//     HOME[0].children.push(...homeRoutes);
// }else if(lang === "en-US"){
//     HOME_EN[0].children.push(...homeRoutes);
// }

const routes = [
    // ...HOME,
    // ...SINGLE,
    // ...HOME_EN,
    // ...SINGLE_EN,
    {
        path: '/',
        name: 'Home',
        redirect:`${lang}/controller`,
        component: Home,
        children:homeRoutes
    },
    {
        path:'/login',
        name:'Login',
        component:Login
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router
